export default "__VITE_ASSET__CadEhwgq__"